module.exports = __webpack_public_path__ + "img/atcast.c0762205.png";